import { LANGUAGE_LIST } from './languagesList';

export const LANGUAGES = LANGUAGE_LIST.map(({ value }) => value);
